import {
  AgxRow,
  AgxColumn,
  AgxTypography,
  AgxToggleSwitch,
} from '@urbanx/agx.ui-components2'
import { TaskStepDto } from '@urbanx/agx.activities.client'

export const NSWAgreementSignatureStageSteps = ({
  tasksStage: tasksStage,
  updateTaskStep: updateTaskStep,
}: {
  tasksStage: TaskStepDto[]
  updateTaskStep: (step: TaskStepDto, isChecked: boolean) => void
}) => {
  const showHeader = (index: number) => index === 0;
  const headerLabels: Record<number, string> = {
    0: "Page 7 - Signatures",
  };

  return (
    <AgxColumn gap="spacing-xl" padding={{ bottom: 'spacing-8xl' }} fill>
      {tasksStage.map((step, index) => {
        const header = headerLabels[index];
        return (
          <>
            {showHeader(index) && (
              <AgxTypography size="medium" type="title" id="modalTitle">
                {header}
              </AgxTypography>
            )}
            <AgxRow
              gap="spacing-lg"
              justifyContent="space-between"
              alignItems="flex-start"
              fill
              key={step.order + 'row'}
            >
              <AgxRow >
                <AgxTypography
                  id={'lbllicenseeDetails'}
                  type={'body_ui'}
                  size={'small'}
                >
                  {step.name}
                </AgxTypography>
              </AgxRow>

              <AgxRow  justifyContent="right" alignItems="flex-start">
                <AgxToggleSwitch
                  id={`step-${step.order}`}
                  checked={step.isCompleted ?? false}
                  onChange={(isChecked: boolean) =>
                    updateTaskStep(step, isChecked)
                  }
                />
              </AgxRow>
            </AgxRow>

          </>
        )
      })}
    </AgxColumn>
  )
}

export default NSWAgreementSignatureStageSteps
